module.exports = require("underscore");


//////////////////
// WEBPACK FOOTER
// external "underscore"
// module id = 35
// module chunks = 0


// WEBPACK FOOTER //
// webpack:/external "underscore"